// extracted by mini-css-extract-plugin
export default {"wrapper":"WPMDisplay_wrapper__tXl3T"};